import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { invalidateKeys, queryKeys } from '@/lib/query-keys';

import type { CreatePackageInput, PackageWithItems } from '../types';

export const useCreatePackage = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (input: CreatePackageInput) =>
      apiClient.post<PackageWithItems>('packages', input),
    onSuccess: () => {
      invalidateKeys(queryClient, queryKeys.packages.all());
      toast.success('Package created');
    },
    onError: (error: Error) => {
      // The server's message is the useful one — e.g. a deposit refused
      // because Stripe can't take payments.
      toast.error(error.message || 'Failed to create package');
    },
  });

  return {
    createPackage: mutation.mutate,
    createPackageAsync: mutation.mutateAsync,
    isCreating: mutation.isPending,
  };
};
